import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../app/shared/shared.services";
import { HeaderService } from "../../../shared/service/header.service";
import { ProjectService } from "../../../shared/service/project.service";
import { UserService } from "../../../shared/service/user.service";
import { SwitchAccountDialog } from "../../../shared/dialog/switch-account-dialog/switch-account-dialog";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-subheader",
  templateUrl: "./subheader.component.html",
})
export class SubheaderComponent implements OnInit {
  project: any = [];
  constructor(
    public headerService: HeaderService,
    public sharedService: SharedService,
    private projectSvc: ProjectService,
    public userSvc: UserService,
    private dialog: MatDialog
  ) {
    this.headerService.header = null;
    this.projectSvc.SwitchProjectParams();
    this.projectSvc.Current$.subscribe(
      () => (this.project = this.projectSvc.Projects)
    );
  }

  ngOnInit() {
    this.userSvc.Init();
  }

  toggleSideNav() {
    if (window.innerWidth < 768) {
      this.sharedService.sideNav.toggle();
    }
  }

  switchAccontDialog() {
    if (this.userSvc.AccountList.length == 0) return ;
    this.dialog.open(SwitchAccountDialog, {
      width: "320px",
      panelClass: "switch-project-dialog",
    });
  }
}
